export enum HideableWalletFeature {
    Withdrawal = 'withdrawal',
    Deposit = 'deposit',
}

export function getHiddenWalletFeatures(): HideableWalletFeature[] {
    return window.condaHiddenWalletFeatures || []
}

export function checkWalletFeatureHidden(feature: HideableWalletFeature): boolean {
    return getHiddenWalletFeatures().includes(feature)
}
